import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { Divider, Link } from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';


const AboutOCPF = (): JSX.Element => {

  const directorsTimeline = [
    {
      name: 'William C. Campbell',
      years: '2021 - Present',
    },
    {
      name: 'Michael J. Sullivan',
      years: '2020 - 2021 pro tem',
    },
    {
      name: 'Michael J. Sullivan',
      years: '	(1994 - 2019)',
    },
    {
      name: 'Mary F. McTigue',
      years: '(1988 - 1994)',
    },
    {
      name: 'Dennis J. Duffin',
      years: '	(1982 - 1988)',
    },
    {
      name: 'Charles J. Doherty',
      years: '(1976 - 1982)',
    },
    {
      name: 'Norm Gleason',
      years: '(1974 - 1976)',
    },
  ]

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
          variant="h5"
          align={'left'}
          data-aos={'fade-up'}
          sx={{
            fontWeight: 700,
          }}
          paddingTop={3}
          gutterBottom
          marginBottom={2}
        >
          About Us <Typography component="span" variant="caption" color="text.secondary">A Brief History of the Agency and Its Mission</Typography>
        </Typography>
        <Divider />

        <Grid container marginTop={3} marginBottom={3}>
          <Grid size={12}>
            <Typography variant='h6'>
              The Agency
            </Typography>
            <Typography marginTop={2} variant='body1' component='p'>
              The Office of Campaign and Political Finance is an independent state agency that administers Massachusetts General Law <Link href='/Legal/CampaignFinanceLaw' target='_blank'>Chapter 55</Link>, the campaign finance law, and <Link href='/Legal/PublicFinancingLaw' target='_blank'>Chapter 55C</Link>, the limited public financing program for statewide candidates. OCPF is the depository for reports of contributions received and expenditures made by candidates and political committees.
            </Typography>
            <Typography marginTop={2} variant='body1' component='p'>
              OCPF receives and reviews reports filed by hundreds of candidates and committees to ensure compliance with the statute and regulations. The agency places an emphasis on education to assist candidates and stakeholders in navigating the campaign finance law through guides, videos and memos posted to this website, online and in-person educational programs, and the availability of staff to provide guidance.
            </Typography>
          </Grid>
        </Grid>

        <Divider />

        <Grid container marginTop={3} marginBottom={3}>
          <Grid size={12}>
            <Typography variant='h6'>
              The Director
            </Typography>
          </Grid>
          <Grid size={12}>
            <Typography marginTop={2} variant='body1' component='p'>
              OCPF is headed by a director who is appointed unanimously by a bi-partisan commission consisting of the Secretary of the Commonwealth, the chairs of the Democratic and Republican State Committees and the dean of a law school appointed by the Governor. The Director serves a six-year term and may be selected for a succeeding term or terms.
            </Typography>

            <Timeline position="alternate">
              {directorsTimeline.map((director, index) => (
                <TimelineItem key={index}>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ textAlign: 'left' }}>
                    <Typography component={'p'} variant="body2">
                      {director.name}
                    </Typography>
                    <Typography component={'p'} variant="body2" color="text.secondary">
                      {director.years}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          </Grid>
        </Grid>

        <Divider />

        <Grid container marginTop={3} marginBottom={3}>
          <Grid size={12}>
            <Typography variant='h6'>
              Candidate and Committee Reports
            </Typography>
            <Typography marginTop={2} variant='body1' component='p'>
              OCPF receives and maintains thousands of reports from Massachusetts state and local candidates and political committees.
            </Typography>
            <Typography marginTop={2} variant='body1' component='p'>
              Candidates and political committees who file reports with OCPF are those seeking election to statewide, legislative, mayoral, county, district, and governor's council office, as well as city council in cities with populations of 65,000 or more, namely Boston, Brockton, Cambridge, Fall River, Framingham, Haverhill, Lawrence, Lowell, Lynn, Malden, New Bedford, Newton, Quincy, Somerville, Springfield, Waltham and Worcester; and state party committees. All other candidates file their reports with their local election officials but are subject to oversight by OCPF.
            </Typography>
            <Typography marginTop={2} variant='body1' component='p'>
              PACs and IEPACs organized to support or oppose a candidate who files with OCPF, and ballot question committees formed to support or oppose a ballot question appearing on a state election ballot file with OCPF, while all other PACs, IEPACs and ballot question committees file with their local election officials. Depending upon the candidates supported or opposed, PACs and IEPACs may have to simultaneously file reports with OCPF and their local election officials.
            </Typography>
            <Typography marginTop={2} variant='body1' component='p'>
              Most reports filed with OCPF from January 2002 to the present day, as well as other related documents and correspondence, are available at <Link href='/home1' target='_blank'>www.ocpf.us</Link> Earlier reports are in secure off-site storage and are available for public inspection at our office in Room 411 of the John W. McCormack Building, One Ashburton Place, Boston, Massachusetts by appointment. Some reports, such as reports of casino ballot question spending, are scanned and made available for viewing on the OCPF website. Local election officials maintain reports in their office until December 31, six years from the date of the relevant election for all other local offices, as well as PACs and IEPACs supporting or opposing candidates who file with that office and ballot question committees who support or oppose a ballot question on a local ballot. Local election officials also post the reports on their local website for any candidate or political committee with more than $1,000 in activity during the reporting period.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default AboutOCPF;